import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import { chunk } from "../../helpers";
import store from "../../store";
import {
  setRedirectionLink,
  getEducationLevel,
  get_User_Subistrict,
  getTradeData,
  get_pm_District,
  getQualificationData,
  RegisterPmScheme,
} from "../../actions/accountAction";
import {
  setSelfEmploymentSearchResults,
  postSelfEmploymentSearch,
} from "../../actions/jobseekerAction";
import { get_sector_self_employment } from "../../actions/jobpostAction";
import ServerSetting from "../../config.json";
import Validation from "../hoc/Validation";

const RESULT_PER_PAGE = 25;

class PmVikasScheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      formData: [],
      submitted: false,
      job: [],
      submissionSuccess: false,
      selectedCourseName: ""
    };

    store.dispatch(getEducationLevel());
    store.dispatch(get_sector_self_employment());
    store.dispatch(postSelfEmploymentSearch({ ...this.state.formData }));
    store.dispatch(get_pm_District());

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handlePageChange = (activePage) => {
    this.setState({ activePage });
  };

  createDistoption = () => {
    const { PmDistrict } = this.props.actionReducer;
    let Distoption = [];


    if (PmDistrict && PmDistrict?.data?.length > 0) {
      PmDistrict?.data?.map((dist, index) => {
        Distoption.push(
          <option key={dist.id} value={dist.id}>
            {dist.name}
          </option>
        );
      });
    }

    return Distoption;
  };

  componentDidMount() {
    document.title = this.props.t("pmVikasRojgar.pmVikashScheme", {
      param: "react",
    });
  }

  submitSearch = (e) => {
    e.preventDefault();
    if (!this.state.submitted) {
      store.dispatch(postSelfEmploymentSearch({ ...this.state.formData }));
      this.setState({ submitted: true });
    }
  };

  handleInputs = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let formData = this.state.formData;
    if (name === "district_id") {
      store.dispatch(getTradeData(value));
      store.dispatch(get_User_Subistrict(value));
      delete formData["subdistrict_id"];
    }
    if (!value) {
      delete formData[name];
    } else {
      formData[name] = value;
    }
    this.setState({ formData, submitted: false });
  };

  getToSelfEmp = () => {
    if (
      this.props.actionReducer.Loginuser &&
      this.props.actionReducer.Loginuser.id
    ) {
      this.props.router.push(`search-pm-scheme`);
    } else {
      store.dispatch(setRedirectionLink(`search-pm-scheme`));
      this.props.router.push("/signin");
    }
  };

  componentWillUnmount() {
    store.dispatch(setSelfEmploymentSearchResults([]));
  }

  redirect = () => {
    document.getElementById("close-btn").click();
  };

  // async handleUserInput(e) {
  //   const name = e.target.name;
  //   let value = e.target.value;
  //   let type = e.target.type;
  //   let key = e.target.key;

  //   if (type === "text") {
  //     let regex = /^[A-Za-z0-9 ]+$/;
  //     if (!regex.test(value) && value) {
  //       return false;
  //     }
  //   }

  //   if (name === "district_id") {
  //     store.dispatch(getTradeData(value));
  //   }

  //   if (name === "course") {
  //     store.dispatch(getTradeData(value));
  //   }

  //   this.setState({
  //     formData: {
  //       ...this.state.formData,
  //       [name]: value,
  //     }
  //   });
  // }


  async handleUserInput(e) {
    const name = e.target.name;
    let value = e.target.value;
    let type = e.target.type;

    if (type === "text") {
      let regex = /^[A-Za-z0-9 ]+$/;
      if (!regex.test(value) && value) {
        return false;
      }
    }

    // Base formData update
    let updatedFormData = {
      ...this.state.formData,
      [name]: value,
    };

    // Handle cascading resets
    if (name === "district_id") {
      // When district changes -> reset course, qualification, age
      updatedFormData.education_level = "";
      updatedFormData.qualification = "";
      updatedFormData.age = "";

      store.dispatch(getTradeData(value)); // fetch courses for district
    }

    if (name === "course") {
      store.dispatch(getTradeData(value));
    }

    this.setState({
      formData: updatedFormData,
    });
  }



  handleSubmit(event) {
    event.preventDefault();
    const { formData } = this.state;

    const user = {
      full_name: formData.fullname || "",
      father_spouse_name: formData.fatherspousename || "",
      district_id: formData.district_id ? parseInt(formData.district_id, 10) : null,
      course_id: formData.education_level?.length
        ? parseInt(formData.education_level[0], 10)
        : null,
      qualification_id: formData.qualification
        ? parseInt(formData.qualification, 10)
        : null,
      age: formData.age ? formData.age : null,
      mobile_no: formData.mobile || "",
    };

    if (this.props.validator.allValid()) {
      // Dispatch only if all fields are valid
      store.dispatch(RegisterPmScheme(user))
        .then(() => {
          // Save mobile temporarily
          localStorage.setItem("otp_mobile", user.mobile_no);

          // Redirect to OTP page
          // this.props.router.push("/pm-otp-vertification");

          // const selectedCourse = this.props.actionReducer.tradeData.find(
          //   (d) => d.id === parseInt(user.course_id, 10)
          // );

          // Reset form & hide messages **after success**
          this.props.validator.hideMessages();
          this.setState({ formData: {}, submissionSuccess: true }); // reset form
          if (this.feedbackRef.current) this.feedbackRef.current.click();

          // Scroll to top if needed
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        })
        .catch((err) => {
          console.error("Submission failed:", err);
        });
    } else {
      // Show validation messages
      this.props.validator.showMessages();
      this.forceUpdate(); // needed to trigger render and show messages
    }
  }


  render() {
    const searchResult = chunk(
      this.props.JobseekerReducer.selfEmployment,
      RESULT_PER_PAGE
    );
    const Mainprops = this.props;
    const { validator } = this.props;
    const { activePage, job, formData } = this.state;

    const SERVER_PATH = ServerSetting[process.env.NODE_ENV].SERVER_PATH;

    return (
      <div>
        <section className="total-job httge">
          <div className="container">
            <div className={`row py-5 pb-0`}>
              <div className="alignflexs pb-3">
                <p className="maintitle clrwht">
                        {this.props.t("pmVikasRojgar.pmVikasRojgarTitle", {
                          param: "react",
                        })}
                      </p>
                <div className="text-end p-0">
                        <a className="pdfTitle p-0 sdwqq" href="/docs/courses_and_eligibility_PM_VIKAS.pdf" target="_blank" rel="noopener noreferrer">
                          {this.props.t("pmVikasRojgar.pdfTitle", {
                            param: "react",
                          })}
                        </a>
                      </div>
              </div>
            </div>
          </div>
        </section>

        <section className="job-details mtmins">
          <div className="container">
            {
              this.state.submissionSuccess ? (
                <div className="thank-you-message text-center p-4">
                  <h3>
                    Thank you, your details for the course/trade{" "}
                    <strong>
                      (  {
                        this.state.selectedCourseName
                      })
                    </strong>{" "}
                    have been submitted successfully.
                  </h3>

                  {/* ✅ Go to Home button */}
                  <button
                    type="button"
                    className="btn btn-primary btn-primary2 px-5 py-3 m-0 mt-3"
                    onClick={() => this.props.router.push("/")}
                  >
                    Go to Home
                  </button>
                </div>
              ) :
                (
                  <div className="row">
                    <div
                      className={`col-lg-6 col-sm-12 right-sidebar-scroll m-auto`}
                    >
                      <div className="right-sidebar jobdge">
                        <div className="first-job mb-3 pt-3 px-1">
                            <form onSubmit={this.handleSubmit}>
                                <div className="row mx-0 mainboxhead newspaceitme pmVikasLable">

                                  <div className="col-lg-12 mb-3">
                                    <div className="pminputbox">
                                      <label htmlFor="fullname" id="fullname">
                                        {this.props.t("pmVikas.fullName", { param: "react" })}
                                        <span
                                          aria-hidden="true"
                                          className="errorclr ml-2"
                                        >*</span>
                                      </label>
                                      <input
                                        autoComplete="full-name"
                                        type="text"
                                        onChange={(event) =>
                                          this.handleUserInput(event)
                                        }
                                        placeholder={this.props.t(
                                          "forms.enterFullname",
                                          { param: "react" }
                                        )}
                                        value={this.state.formData?.fullname || ""}
                                        className="form-control"
                                        id="fullname"
                                        name="fullname"
                                        aria-label="Enter Full Name"
                                        // required
                                        aria-required="true"
                                        aria-describedby="fullname"
                                      />
                                      {validator.message("fullname", this.state.formData?.fullname, "required|max:50|alpha_space")}
                                    </div>
                                  </div>

                                   <div className="col-lg-12 mb-3">
                                    <p htmlFor="mobile" className="registrationFormDivLabel">
                                      {this.props.t("pmVikas.mobile_no", { param: "react" })}
                                      <span className="errorclr ml-2">*</span>
                                    </p>
                                    <input
                                      autoComplete='mobile'
                                      onChange={(event) => this.handleUserInput(event)}
                                      type="number"
                                      className="form-control"
                                      placeholder={this.props.t("forms.10mobile", { param: "react" })}
                                      name="mobile"
                                      id="mobile"
                                      aria-label="Enter Mobile Number"
                                    />
                                    {validator.message(
                                      "mobile",
                                      this.state.formData.mobile,
                                      "required|phone"
                                    )}
                                  </div>

                                  <div className="col-lg-12 mb-3">
                                    <div className="pminputbox">
                                      <label htmlFor="fatherspousename" id="fatherspousename">
                                        {this.props.t("pmVikas.father_spouse", { param: "react" })}
                                        <span
                                          className="errorclr ml-2"
                                          aria-hidden="true"
                                        >*</span>
                                      </label>
                                      <input
                                        autoComplete="father-spouse-name"
                                        type="text"
                                        onChange={(event) =>
                                          this.handleUserInput(event)
                                        }
                                        placeholder={this.props.t(
                                          "forms.enterFatherSpousename",
                                          { param: "react" }
                                        )}
                                        value={this.state.formData?.fatherspousename || ""}
                                        className="form-control"
                                        id="fatherspousename"
                                        name="fatherspousename"
                                        aria-label="Enter Father Spouse Name"
                                        // required
                                        aria-required="true"
                                        aria-describedby="fatherspousename"
                                      />
                                      {validator.message("fatherspousename", this.state.formData?.fatherspousename, "required|max:50|alpha_space")}
                                    </div>
                                  </div>

                                  <div className="col-lg-12 mb-3">
                                    <label htmlFor="district">
                                      {this.props.t("pmVikas.district", { param: "react" })}
                                      <span
                                        className="errorclr ml-2"
                                        aria-hidden="true"
                                      >*</span>
                                    </label>
                                    <select
                                      value={this.state.formData?.district_id || ""}
                                      className="form-control w-100"
                                      name="district_id"
                                      aria-label="Select district"
                                      onChange={(e) => this.handleUserInput(e)}
                                    >
                                      <option value="" disabled>
                                        {this.props.t("forms.selectDis", {
                                          param: "react",
                                        })}
                                      </option>
                                      {this.createDistoption()}
                                    </select>
                                    {validator.message("district_id", this.state.formData.district_id, "required")}
                                  </div>

                                  <div className="col-lg-12 mb-3">
                                    <label htmlFor="course">
                                      {this.props.t("pmVikas.course_trade", { param: "react" })}
                                      <span
                                        className="errorclr ml-2"
                                        aria-hidden="true"
                                      >*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      name="education_level"
                                      id="course/trade"
                                      aria-required="true"
                                      aria-label="Select course/trade"
                                      style={{
                                        width: "100%",
                                      }}
                                      value={this.state.formData.education_level || ""}
                                      onChange={(e) => {
                                        const selected = e.target.value;
                                        const selectedCourse = Mainprops.actionReducer.tradeData.find(
                                          (d) => d.id == selected
                                        );

                                        this.setState({
                                          formData: {
                                            ...this.state.formData,
                                            education_level: selected,
                                            qualification: "", // ✅ reset qualification
                                            age: ""            // ✅ reset age
                                          },
                                          selectedCourseName: selectedCourse ? selectedCourse.course : ""
                                        });
                                        store.dispatch(getQualificationData(selected));
                                      }}
                                    >
                                      <option value="" disabled>
                                        {this.props.t("pmVikasRojgar.selectTrade", { param: "react" })}
                                      </option>
                                      {Mainprops.actionReducer.tradeData.map((data) => (
                                        <option key={data.id} value={data.id}>
                                          {data.course}
                                        </option>
                                      ))}
                                    </select>
                                    {validator.message("education_level", this.state.formData.education_level, "required")}
                                  </div>

                                  <div className="col-lg-12 mb-3">
                                    <label htmlFor="Qualification">
                                      {this.props.t("pmVikas.qualification", { param: "react" })}
                                      <span
                                        className="errorclr ml-2"
                                        aria-hidden="true"
                                      >*</span>
                                    </label>
                                    <select
                                      className="form-control w-100"
                                      name="qualification"
                                      aria-label="Select Qualification"
                                      value={this.state.formData.qualification || ""}
                                      onChange={(e) =>
                                        this.setState({
                                          formData: {
                                            ...this.state.formData,
                                            qualification: e.target.value,
                                            age: ""
                                          },
                                        })
                                      }
                                    >
                                      <option value="" disabled> {this.props.t("forms.qualification", { param: "react" })}</option>
                                      {this.props.actionReducer.qualifications
                                        .length > 0 &&
                                        this.props.actionReducer.qualifications.map(
                                          (q) => (
                                            <option key={q.course_qualification_id} value={q.course_qualification_id}>
                                              {q.name}
                                            </option>
                                          )
                                        )}
                                    </select>
                                    {validator.message(
                                      "qualification", // singular, matches state key
                                      this.state.formData.qualification, // matches the value you set
                                      "required"
                                    )}
                                  </div>

                                  <div className="col-lg-12 mb-3">
                                    <label htmlFor="age">
                                      {this.props.t("pmVikas.age", { param: "react" })}
                                      <span
                                        className="errorclr ml-2"
                                        aria-hidden="true"
                                      >*</span>
                                    </label>
                                    <select
                                      onChange={(event) => this.handleUserInput(event)}
                                      className="form-control"
                                      name="age"
                                      id="age"
                                      aria-required="true"
                                      aria-label="Select Age"
                                      value={this.state.formData.age || ""}
                                    >
                                      <option value="" disabled>-- {this.props.t("forms.ageName", { param: "react" })} --</option>
                                      {this.props.actionReducer.qualifications.map((qual) => {
                                        const minAge = parseInt(qual.req_min_age, 10);
                                        const maxAge = parseInt(qual.req_max_age, 10);

                                        const ageOptions = [];
                                        for (let age = minAge; age <= maxAge; age++) {
                                          ageOptions.push(age);
                                        }

                                        return ageOptions.map((age) => (
                                          <option key={`${qual.course_qualification_id}-${age}`} value={age}>
                                            {age}
                                          </option>
                                        ));
                                      })}
                                    </select>
                                    {validator.message(
                                      "age",
                                      this.state.formData.age,
                                      "required"
                                    )}
                                  </div>

                                  <div className="col-lg-12 my-3 text-end">
                                    <button
                                      aria-label="Submit"
                                      type="submit"
                                      className="btn btn-primary btn-primary2 px-5 m-0"
                                    // onClick={this.getToSelfEmp}`
                                    >
                                      {/* Submit */}
                                      {this.props.t('jobMela.submit', { param: 'react' })}
                                    </button>
                                  </div>
                                  
                                </div>
                            </form>
                        </div>
                      </div>
                    </div>
                  </div>

                )
            }

          </div>
        </section >
      </div >
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};
// export default connect(mapStateToProps)(translate(PmVikasScheme));
export default connect(mapStateToProps)(
  translate(
    Validation(PmVikasScheme)
  )
);
